import {MenuItemConfig} from '../core/settings/settings';

/** First dashboard-nav item: LibreChat. Keep in sync with DashboardAiChatMenu::ID. */
export const DASHBOARD_AI_CHAT_MENU_ID = 'dashboard_ai_chat';

export function isDashboardAiChatMenuItem(
  item: Pick<MenuItemConfig, 'id'>,
): boolean {
  return item.id === DASHBOARD_AI_CHAT_MENU_ID;
}

export const dashboardAiChatNavClassName =
  'opacity-100 rounded-full bg-primary/12 px-12 py-6 font-semibold text-primary no-underline hover:bg-primary/18 hover:no-underline hover:opacity-100';
